import { LEVEL, LEVEL_ORDER } from "./constants/levels"
import { hasAdvancedPastLevel } from "./displayUtils"

export const shouldShowAdditionalRequirements = ({
  activeLevel,
  currentLevelKey,
  mostRecentCompletedLevelKey,
}) => {
  const userCurrentLevelIndex = LEVEL_ORDER.indexOf(currentLevelKey)
  const activeLevelIndex = LEVEL_ORDER.indexOf(activeLevel)

  return (
    activeLevel !== LEVEL.QUALIFYING &&
    activeLevelIndex >= userCurrentLevelIndex &&
    !hasAdvancedPastLevel(
      activeLevel,
      currentLevelKey,
      mostRecentCompletedLevelKey,
    )
  )
}
